import { Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { IPreparedNewsPublicated, TNewsColumns } from 'shared/types/news.types';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import SearchComponent from 'shared/components/search/news-faq';
import { SearchKeysNews } from 'shared/enums/news';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TProps = {
  dataSource: IPreparedNewsPublicated[];
  columns: TNewsColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch: (data: string, key: SearchKeysNews) => void;
  onclickToRow?: (id: number) => void;
};

const NewsTable: FC<TProps> = ({
  columns,
  currentPage,
  currentSize,
  dataSource,
  setCurrentPage,
  setCurrentSize,
  total,
  onclickToRow,
  onSearch,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysNews.SEARCH_TITLE]: {
            name: SearchKeysNews.SEARCH_TITLE,
            alias: 'Заголовок',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_TITLE,
              placeholder: 'Введите заголовок',
              onSearch: data => {
                onSearch(data, SearchKeysNews.SEARCH_TITLE);
              },
            }),
          },
          [SearchKeysNews.SEARCH_NAME]: {
            name: SearchKeysNews.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch(data, SearchKeysNews.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysNews.SEARCH_ID]: {
            name: SearchKeysNews.SEARCH_ID,
            alias: 'Номер',
            node: NumberFormItem({
              name: SearchKeysNews.SEARCH_ID,
              placeholder: 'Введите номер новости',
              onSearch: data => {
                onSearch(data, SearchKeysNews.SEARCH_ID);
              },
            }),
          },
        }}
      />
      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName="row"
        pagination={false}
        bordered
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (onclickToRow) {
                onclickToRow(+record.id);
              }
            },
          };
        }}
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          showSizeChanger
          current={currentPage}
          total={total}
          pageSize={currentSize}
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};

export default NewsTable;
